import { render, staticRenderFns } from "./VoiceControl.vue?vue&type=template&id=480e40fd&"
import script from "./VoiceControl.vue?vue&type=script&lang=js&"
export * from "./VoiceControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports